const api = require("./api");
const auth = require("./auth");
const broadcast = require("./broadcast");
const config = require("./config");
const formatter = require("./formatter")(api);
const utils = require("./utils");

const scoop = {
  api,
  auth,
  broadcast,
  config,
  formatter,
  utils
};

if (typeof window !== "undefined") {
  window.scoop = scoop;
}

if (typeof global !== "undefined") {
  global.scoop = scoop;
}

exports = module.exports = scoop;



// WEBPACK FOOTER //
// ./src/browser.js